import { componentTheme } from '@/styles/ElementSliderSlide';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { standaloneComponent } from 'modules/dynamic-components';
import { StandaloneLinkProps } from '../../Link';

const Link = standaloneComponent<StandaloneLinkProps>('ElementLink');

export type SlideLinkProps = StandaloneLinkProps;

export const SlideLinkComponent: StandaloneComponent<SlideLinkProps> = (props) => (
  <Link
    {...mergeProps(
      {
        options: {
          theme: componentTheme('link'),
        },
      },
      props
    )}
  />
);
